import axios from "axios";
import map from './pcbangmap.svg'
import { useState, useEffect, useRef, useContext, createContext, useReducer } from 'react';
import { Page, capitalize, deepcopy, getBearerToken, isAdmin, isLoggedIn, dynamicResourceLinks, ShowConditonally } from "./util";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import Draggable from "react-draggable";
import Select from "react-select";
import pcbanglogo from './pcbanglogo.png';
import { isEqual } from 'lodash';
import { globalContext } from "./App";

var circleDiameter = 30;
var topsectionBottompadding = 20
var topsectionHeight = 50
var topsectionTotalHeight = topsectionBottompadding + topsectionHeight;
var mapHeight = 400;
var mapWidth = 800;
const localContext = createContext({})
var statusLabels = {
	offline: "Offline",
	online: "Available",
	"in use": "Occupied",
	"out of service": "Out Of Service"
}

const updateSelectedDeviceInLocalDevices = (localDevices, setLocalDevices, selectedDevice) => {
	var desiredIndex = localDevices.findIndex(dev => dev.id === selectedDevice.id)
	if (!localDevices.some(dev => {
		return dev.attributes.name === selectedDevice.name && dev.attributes.type === selectedDevice.type.value && dev.attributes.status === selectedDevice.status.value
	})) {
		// console.log("updating", { localDevices, selectedDevice })
		if (desiredIndex !== -1) {
			var tmp = deepcopy(localDevices)
			// console.log({tmp})
			var newUpdatedDevice = { ...tmp[desiredIndex], attributes: { ...tmp[desiredIndex].attributes, name: selectedDevice.name, type: selectedDevice.type.value, status: selectedDevice.status.value } }
			// console.log({newUpdatedDevice})
			tmp[desiredIndex] = newUpdatedDevice
			setLocalDevices(tmp)
			return tmp;
		}
	}
	return localDevices;
}

var typeLabels = {
	pc: "PC",
	console: "Console",
	arcade: "Arcade",
	other: "Other"
}

const optionsType = [
	{ value: 'pc', label: 'PC' },
	{ value: 'console', label: 'Console' },
	{ value: 'arcade', label: 'Arcade' },
	{ value: 'other', label: 'Other' },
];
const optionsStatus = [
	{ value: 'online', label: statusLabels['online'] },
	{ value: 'offline', label: statusLabels['offline'] },
	{ value: 'in use', label: statusLabels['in use'] },
	{ value: 'out of service', label: statusLabels['out of service'] },
];

const DraggableDeviceDiv = ({ type, bgcolor, bgimage, isEditing, x, y, content, status, id, name, deviceIndex }) => {
	var { selectedDevice, selectedDeviceDispatch, localDevices, setLocalDevices } = useContext(localContext)
	var normalizeCoordsForVisuals = (a, b) => {
		var finala, finalb;
		if (a < 0) {
			finala = topsectionHeight / 2 - circleDiameter / 2 + circleDiameter * (deviceIndex - 1);
		}
		else {
			finala = a
		}
		if (b < 0) {
			finalb = topsectionHeight / 2 - circleDiameter / 2;
		}
		else {
			finalb = b + topsectionHeight;
		}
		return { x: finala, y: finalb }
	}
	var normalizeCoordsForRemote = (a, b) => {
		return { x: b < topsectionHeight ? -1 : a, y: b < topsectionHeight ? -1 : b - topsectionHeight }
	}
	var obj = normalizeCoordsForVisuals(x, y);
	x = obj.x;
	y = obj.y;
	const ref = useRef(null);
	var dataTip = { "data-tip": name + " - " + capitalize(statusLabels[status]) }
	var onSelect = (e) => {
		// console.log({ selectedid: selectedDevice.id, id })
		updateSelectedDeviceInLocalDevices(localDevices, setLocalDevices, selectedDevice);
		var sdev = { id, name, status: { label: statusLabels[status], value: status }, type: { label: typeLabels[type], value: type } }
		if (selectedDevice.id !== id)
			selectedDeviceDispatch(sdev)
	}
	var dataBefore = { "data-before": name + " - " + capitalize(statusLabels[status])}
	var child = <div
		{...dataTip}
		key={name}
		ref={ref}
		className={`flex-ai-cr flex-jc-cr device device_tag ${type.replace(/ /g, "-")} ${status.replace(/ /g, "-")} ${((selectedDevice.id === id) && (id > -3 || selectedDevice.name === name)) && isLoggedIn() && isEditing ? "selected" : ""}`}
		{...dataBefore}
		style={{
			width: circleDiameter,
			height: circleDiameter,
			borderRadius: "999px",
			backgroundColor: bgcolor,
			backgroundImage: `url(${bgimage})`,
			backgroundPosition: "center",
			backgroundRepeat: "no-repeat",
			position: "absolute",
			top: isEditing ? 0 : y,
			left: isEditing ? 0 : x,
			cursor: "pointer",
			opacity: "0.9",
		}}
		{...(!isEditing && { onClick: onSelect })}

	>
		<div
			className="device_tag"
			style={{
				textAlign: "center",
				fontFamily: "'Cera Round Pro'",
				fontSize: "85%",
				userSelect: "none",
				marginBottom: "-1px"
			}}
		>
			{content}
		</div>
	</div>
	return (
		<ShowConditonally cond={isEditing}>
			<Draggable
				key={name}
				nodeRef={ref}
				position={{ x, y }}
				scale={1}
				disabled={!isEditing}
				bounds={{ top: 0, left: 0, right: mapWidth - circleDiameter, bottom: mapHeight + topsectionTotalHeight - circleDiameter }}
				onStart={onSelect}
				onStop={(e, data) => {
					if (isEditing) {
						var updatedDevice = { id, attributes: { name, type, status, ...normalizeCoordsForRemote(data.x, data.y) } }
						var toUpdateIndex = localDevices.findIndex(dev => dev.attributes.name === name)
						var tmp = deepcopy(localDevices)
						tmp[toUpdateIndex] = updatedDevice
						setLocalDevices(tmp)
					}
				}}
			>
				{child}
			</Draggable>
			<>
				{child}
			</>
		</ShowConditonally>
	);
}

const GetDeviceDivs = () => {
	var { localDevices, remoteDevices, editMode: isEditing } = useContext(localContext);
	var devices = isEditing ? localDevices : remoteDevices;
	if (devices) {
		var deviceIndex = 0;
		return devices.map(
			(_device) => {
				var { id, name, type, status, x, y } = { id: _device.id, ..._device.attributes };
				if ((x === -1 || y === -1) && !isLoggedIn()) {
					return <></>
				}
				if (y === -1) {
					deviceIndex++;
				}
				var match = name.match(/\d?\d$/g)
				var number = "00"
				if (match && match.length > 0) {
					number = Number(match[match.length - 1])
				}
				var content = type === "pc" ? String(number).padStart(2, "0") : ""
				var bgImg = {
					pc: "none",
					console: dynamicResourceLinks("ffffff", 60).gameConsoleIcon,
					arcade: dynamicResourceLinks("ffffff", 60).arcadeIcon
				}
				var getBgImg = () => bgImg[type] || dynamicResourceLinks("ffffff", 60).questionMarkIcon;
				var bgClr = {
					online: "green",
					offline: "gray",
					"in use": "darkorange"
				}
				var getBgClr = () => bgClr[status] || "red";
				return (

					<DraggableDeviceDiv
						key={name}
						bgimage={getBgImg()}
						bgcolor={getBgClr()}
						{...{ content, type, status, id, x, y, isEditing, name, deviceIndex }}
					/>
				);
			}
		)
	}
}

const CRUDForm = ({ children, device, deviceDispatch, inputFieldEditable, fieldsEditable, inputPlaceholder }) => {
	return (
		<form action="" className="flex-jc-sb flex-ai-cr flex-gap10 flex-wrap"
			onSubmit={(e) => {
				e.preventDefault();
			}}
		>
			<div className="left flex-row flex-gap10 flex-wrap flex-js-cr flex-ai-cr">
				<input type="text" id="name" placeholder={inputPlaceholder}
					style={{
						height: "36px",
						borderRadius: "999px",
						border: "1px solid #330033",
						backgroundColor: "#1e031e",
						fontFamily: "Cera Round Pro",
						fontSize: "15px",
						paddingInline: "15px",
						color: "white",
						minHeight: "50px",
					}}
					onChange={(e) => {
						var name = e.target.value
						deviceDispatch({ name, })
					}}
					value={device.name}
					readOnly={!inputFieldEditable}
				/>
				{
					(() => {
						var fn = (a, b) => ({ ...a, color: "white", backgroundColor: "#1e031e", borderColor: "#330033", fontFamily: "Cera Round Pro" })
						return (<>
							<Select
								isSearchable={false}
								value={device.type}
								// defaultValue={selectedOptionType}
								isDisabled={!fieldsEditable}
								onChange={(e) => { deviceDispatch({ type: e }) }}
								options={optionsType}
								placeholder="Device Type"
								styles={{
									control: (a, b) => ({ ...a, color: "white", backgroundColor: "#1e031e", borderColor: "#330033", height: "52px", borderRadius: "999px", paddingInline: "10px" }),
									dropdownIndicator: (a, b) => ({ ...a, color: "white" }),
									menu: fn,
									option: (a, b) => ({ ...a, backgroundColor: b.isFocused ? "#330033" : "#1e031e" }),
									placeholder: (a, b) => ({ ...a, fontFamily: "Cera Round Pro", color: "#988b98" }),
									singleValue: fn,
									indicatorSeparator: (a, b) => ({ ...a, color: "#988b98" }),
								}}
							/>
							<Select
								isDisabled={!fieldsEditable}
								isSearchable={false}
								value={device.status}
								// defaultValue={selectedOptionStatus}
								onChange={(e) => { deviceDispatch({ status: e }) }}
								options={optionsStatus}
								placeholder="Status"
								styles={{
									control: (a, b) => ({ ...a, color: "white", backgroundColor: "#1e031e", borderColor: "#330033", height: "52px", borderRadius: "999px", paddingInline: "10px" }),
									dropdownIndicator: (a, b) => ({ ...a, color: "white" }),
									menu: fn,
									option: (a, b) => ({ ...a, backgroundColor: b.isFocused ? "#330033" : "#1e031e" }),
									placeholder: (a, b) => ({ ...a, fontFamily: "Cera Round Pro", color: "#988b98" }),
									singleValue: fn,
								}}
							/>

						</>);

					})()
				}
				{children[0]}
			</div>
			{children[1]}
		</form>
	);
}

const setDevToNone = (dispatch) => dispatch({ id: -2, name: "", type: null, status: null })

const selectedDeviceReducer = (state, payload) => {
	return { ...state, ...payload }
}

const EH_ACTIONS = {
	UNDO: "UNDO",
	REDO: "REDO",
	APPEND: "APPEND",
	CLEAR: "CLEAR",
}

const editHistoryReducer = (state, action) => {
	console.log("dispatched:", action.type)
	switch (action.type) {
		case EH_ACTIONS.UNDO:
			if (state.index > 0) {
				action.payload._setLocalDevices(state.history[state.index - 1])
				return { ...state, index: state.index - 1 }
			}
			return state
		case EH_ACTIONS.REDO:
			if (state.index + 1 < state.history.length) {
				action.payload._setLocalDevices(state.history[state.index + 1])
				return { ...state, index: state.index + 1 }
			}
			return state
		case EH_ACTIONS.APPEND:
			if (action.payload.localDevices.length !== 0) {
				return { ...state, history: [...state.history.slice(0, state.index + 1), action.payload.localDevices], index: state.index + 1 }
			}
			return { index: -1, history: [] }
		case EH_ACTIONS.CLEAR:
			return { index: -1, history: [] }
		default:
			return state
	}
}

const Map = () => {
	const [errorMessage, setErrorMessage] = useState(" ");
	const [loading, setLoading] = useState(false);
	const { loggedIn } = useContext(globalContext);
	const [remoteDevices, setRemoteDevices] = useState([]);
	const [localDevices, _setLocalDevices] = useState([]);
	const [editHistory, editHistoryDispatch] = useReducer(editHistoryReducer, { history: [], index: -1 })
	const [negativeId, setNegativeId] = useState(-3);
	const [keyStates, setKeyStates] = useState({control: { pressed: false }, shift: { pressed: false }, z: { pressed: false }});

	const setLocalDevices = (val) => {
		if (!isEqual(val, localDevices)) {
			editHistoryDispatch({ type: EH_ACTIONS.APPEND, payload: { localDevices: val, _setLocalDevices } })
		}
		_setLocalDevices(val)
	}
	// const [editHistory, setEditHistory] = useState([]);
	const [editMode, _setEditMode] = useState(false);
	const [selectedDevice, selectedDeviceDispatch] = useReducer(selectedDeviceReducer, { id: -2, name: "", type: null, status: null })
	const [newDevice, newDeviceDispatch] = [selectedDevice, selectedDeviceDispatch]
	const setEditMode = (val) => {
		if (val === true) {
			setLocalDevices([])
			setLocalDevices(remoteDevices);
		}
		else {
			setLoading(false)
		}
		_setEditMode(val);
	}

	
	useEffect(() => {
		var axiosGet = () => axios.get("https://api.pcbang.ma/api/devices").then((res) => {
			if (res.status === 200) {
				setRemoteDevices(res.data.data.filter(dev => {
					delete dev.attributes.createdAt
					delete dev.attributes.updatedAt
					return dev
				}));
			}
		}).catch((err) => {

		})
		axiosGet()
		var inter = setInterval(() => {
			axiosGet()
		}, 1000);
		return () => {
			clearInterval(inter);
		}
	}, [])
	useEffect(() => {
		function onKeyUpEvent(event) {
			var key = event.key.toLowerCase();
			if (key === "control" || key === "shift" || key === "z") {
				setKeyStates(x => {
					var ret = {...x}
					ret[key] = { pressed: false }
					return ret
				})
			}
		}
		function onKeyDownEvent(event) {
			var key = event.key.toLowerCase();
			if (key === "control" || key === "shift" || key === "z") {
				setKeyStates(x => {
					var ret = {...x}
					ret[key] = { pressed: true }
					return ret
				})
			}
			// console.log(event.key)
			// console.log({editMode})
			// console.log({selectedDevice})
			if (event.key === "Delete" && editMode && selectedDevice.id !== -2) {
				setLocalDevices(localDevices.filter(dev => dev.attributes.name !== selectedDevice.name))
				// selectedDeviceDispatch({ id: -2, name: "", status: null, type: null })
				setDevToNone(selectedDeviceDispatch)
			}
		}
		document.addEventListener("keydown", onKeyDownEvent);
		document.addEventListener("keyup", onKeyUpEvent);
		return () => {
			document.removeEventListener("keyup", onKeyUpEvent);
			document.removeEventListener("keydown", onKeyDownEvent);
		}
	}, [editMode, selectedDevice, localDevices, keyStates])
	useEffect(() => {
		// console.log(keyStates);
		if (keyStates.z.pressed) {
			if (keyStates.control.pressed) {
				if (keyStates.shift.pressed) {
					editHistoryDispatch({ type: EH_ACTIONS.REDO, payload: { localDevices, _setLocalDevices } })
					onDeselect();
				}
				else {
					editHistoryDispatch({ type: EH_ACTIONS.UNDO, payload: { localDevices, _setLocalDevices } })
					onDeselect();
				}
			}
		}

	}, [keyStates])

	var onDeselect = () => {
		if (localDevices.some(dev => dev.attributes.name === selectedDevice.name || dev.id === selectedDevice.id))
			setDevToNone(selectedDeviceDispatch)
	}

	return (
		<localContext.Provider value={
			{
				editMode,
				remoteDevices,
				localDevices,
				setLocalDevices,
				selectedDevice,
				selectedDeviceDispatch,
				newDevice: selectedDevice,
				newDeviceDispatch: selectedDeviceDispatch,
				negativeId,
				setNegativeId,
				setErrorMessage,
			}
		}
		>
			<Page className="map">
				{/* <ShowConditonally cond={loggedIn}> */}
				<div className="navpad h50"></div>
				{/* <></>
				</ShowConditonally> */}
				<ControlPannel  style={{ zIndex: "2" }}>
					<div className="w100 flex-column flex-gap10">
						<div className="settings">
							<ShowConditonally cond={isAdmin()}>
								<CustomLink className="users left"
									to={"/users"}
								>
									<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
									<div className="tooltip">
										manage users
									</div>
								</CustomLink>
								<div></div>
							</ShowConditonally>
							<ShowConditonally cond={!editMode}>
								<div className="react-router-link newblog right"
									onClick={() => { setEditMode(!editMode) }}
								>
									<img src={dynamicResourceLinks("ff09ff").editPenIcon} alt="" className="icon" />
									<div className="tooltip">
										Edit
									</div>
								</div>
							</ShowConditonally>
						</div>
						<div className="navpad h20"></div>
						<div className="flex-column flex-gap10" style={{
							display: editMode ? "flex" : "none"
						}}>
							<CRUDForm
								device={selectedDevice}
								deviceDispatch={selectedDeviceDispatch}
								// fieldsEditable={selectedDevice.id !== -2}
								// inputFieldEditable={selectedDevice.id !== -2}
								fieldsEditable={true}
								inputFieldEditable={true}
								inputPlaceholder="Device Name"
							>
								<>
									<ShowConditonally cond={selectedDevice.id !== -2}>
										<input type="text" id="name" placeholder="ID"
											style={{
												height: "36px",
												borderRadius: "999px",
												border: "1px solid #330033",
												backgroundColor: "#1e031e",
												fontFamily: "Cera Round Pro",
												fontSize: "15px",
												textAlign: "center",
												color: "white",
												minHeight: "50px",
												width: "50px"
											}}
											value={selectedDevice.id > -1 ? selectedDevice.id : (selectedDevice.id < -2 ? "NEW" : "")}
											readOnly
										/>
										<div style={{ minHeight: "52px" }}></div>
									</ShowConditonally>
								</>
								<div className="crudbutton flex-ai-cr flex-jc-fe flex-gap10">
									<ShowConditonally cond={selectedDevice.id !== -2}>
										<>
											<button className="pcbangbutton add-device flex-row flex-jc-cr flex-gap5" onClick={
												() => {
													// if (selectedDevice.id !=)
													setLocalDevices(localDevices.filter(dev => dev.attributes.name !== selectedDevice.name))
													// selectedDeviceDispatch({ id: -2, name: "", status: null, type: null })
													setDevToNone(selectedDeviceDispatch)
												}
											}>
												<img src={dynamicResourceLinks("ff09ff").trashCanIcon} style={{ maxWidth: "20px" }} alt="" />
												Delete&nbsp;Device
											</button>
											
										</>
										<>
											<button className="pcbangbutton add-device flex-row flex-jc-cr" onClick={() => {
												if (!newDevice.name) {
													setErrorMessage("The device name cannot be blank");
												}
												else if (localDevices.some(device => device.attributes.name === newDevice.name)) {
													setErrorMessage("A device with that name already exists");
												}
												else if (!newDevice.type?.value) {
													setErrorMessage("The device's type is required");
												}
												else if (!newDevice.status?.value) {
													setErrorMessage("The device's status is required");
												}
												else {
													setLocalDevices(
														[...localDevices,
														{
															id: negativeId,
															attributes: {
																name: newDevice.name,
																status: newDevice.status.value,
																type: newDevice.type.value,
																x: -1,
																y: -1
															}
														}
														])
													setNegativeId(x => x - 1);
													setDevToNone(newDeviceDispatch)
													setErrorMessage(" ")
												}
											}}> <div style={{ color: "#ff09ff", marginTop: "-2px", fontSize: "150%", fontFamily: "Cera Round Pro", fontWeight: "bold" }}>+</div> &nbsp;Add&nbsp;Device</button>
										</>
									</ShowConditonally>
								</div>
							</CRUDForm>
							<div className="savecancel_undoredo container flex-gap10 flex-jc-sb flex-ai-cr flex-wrap">
								<ShowConditonally cond={editMode}>
									<>
										<div className="savecancel flex-jc-fs flex-ai-cr flex-gap10 flex-wrap">
											<div className="react-router-link newblog right"
												onClick={() => {
													const localdev = updateSelectedDeviceInLocalDevices(localDevices, setLocalDevices, selectedDevice);
													var count = 0;
													var deleted = remoteDevices.filter(rdev => !localdev.some(ldev => rdev.id === ldev.id))
													var updated = localdev.filter(ldev => remoteDevices.some(rdev => rdev.id === ldev.id && !isEqual(rdev.attributes, ldev.attributes)))
													var created = localdev.filter(ldev => ldev.id < 0)
													var total = deleted.length + updated.length + created.length;
													if (total > 0) {
														setLoading(true)
														var timeoutid = setTimeout(() => {
															setEditMode(false)
														}, 2000);
														var updateBasedOnCount = () => {
															count++;
															if (count === total) {
																setTimeout(() => {
																	axios.get("https://api.pcbang.ma/api/devices").then((res) => {
																		clearTimeout(timeoutid)
																		if (res.status === 200) {
																			var newrdevs = res.data.data.filter(dev => {
																				delete dev.attributes.createdAt
																				delete dev.attributes.updatedAt
																				return dev
																			})
																			setRemoteDevices(newrdevs);
																		}
																		setEditMode(false);
																	}).catch((err) => {
																		clearTimeout(timeoutid)
																		setEditMode(false);
																	})
																}, 1000)
															}
														}

														console.log({ created, updated, deleted })
														deleted.forEach(dev => {
															axios.delete("https://api.pcbang.ma/api/devices/" + dev.id, { headers: { Authorization: getBearerToken() } })
																.then((res) => { updateBasedOnCount(); console.log({ success: res.status === 200, res }) }).catch((err) => { updateBasedOnCount(); console.log({ err }) })
														})
														updated.forEach(dev => {
															axios.put("https://api.pcbang.ma/api/devices/" + dev.id, JSON.stringify({ data: { ...dev.attributes } }), { headers: { Authorization: getBearerToken(), "content-type": "application/json" } })
																.then((res) => { updateBasedOnCount(); console.log({ success: res.status === 200, res }) }).catch((err) => { updateBasedOnCount(); console.log({ err }) })
														})
														created.forEach(dev => {
															axios.post("https://api.pcbang.ma/api/devices/", JSON.stringify({ data: { ...dev.attributes } }), { headers: { Authorization: getBearerToken(), "content-type": "application/json" } })
																.then((res) => { updateBasedOnCount(); console.log({ success: res.status === 200, res }) }).catch((err) => { updateBasedOnCount(); console.log({ err }) })
														})
													}
													else
														setEditMode(false)
												}}
											>
												<img src={dynamicResourceLinks("ff09ff").saveIcon} alt="" className="icon" />
												<div className="tooltip">
													Save&nbsp;Changes
												</div>
											</div>
											<div className="react-router-link newblog right" onClick={() => {
												setLocalDevices([])
												setEditMode(!editMode)
												setDevToNone(newDeviceDispatch)
												setDevToNone(selectedDeviceDispatch)
												setErrorMessage("")
											}
											}>
												<img src={dynamicResourceLinks("ff09ff").cancelIcon} alt="" className="icon" />
												<div className="tooltip">
													Cancel
												</div>
											</div>
											<ShowConditonally cond={loading}>
												<div>
													<img className="loading" src={dynamicResourceLinks("ffffff").updateIcon} alt="loading..." />
												</div>
											</ShowConditonally>
										</div>
									</>
									<div className="react-router-link newblog right"
										onClick={() => { setEditMode(!editMode) }}
									>
										<img src={dynamicResourceLinks("ff09ff").editPenIcon} alt="" className="icon" />
										<div className="tooltip">
											Edit
										</div>
									</div>
								</ShowConditonally>
								<div className="undoredo container flex-jc-fe flex-ai-cr flex-gap10">
									<button className="undo pcbangbutton"
										onClick={() => {
											editHistoryDispatch({ type: EH_ACTIONS.UNDO, payload: { localDevices, _setLocalDevices } })
											onDeselect();
										}}
									>
										<div className="container flex-jc-cr flex-ai-cr flex-gap5">
											<img src={dynamicResourceLinks("ff09ff").undoIcon} style={{ maxWidth: "20px" }} alt="" className="img" />
											<div className="text" style={{ fontFamily: "'Lemon/Milk'", fontSize: "15px" }}>Undo</div>
										</div>
									</button>
									<button className="redo pcbangbutton"
										onClick={() => {
											editHistoryDispatch({ type: EH_ACTIONS.REDO, payload: { localDevices, _setLocalDevices } })
											onDeselect();
										}}
									>
										<div className="container flex-jc-cr flex-ai-cr flex-gap5">
											<img src={dynamicResourceLinks("ff09ff").redoIcon} style={{ maxWidth: "20px" }} alt="" className="img" />
											<div className="text" style={{ fontFamily: "'Lemon/Milk'", fontSize: "15px" }}>Redo</div>
										</div>
									</button>
								</div>
							</div>
							<div className="errormessage" style={{ fontFamily: "Cera Round Pro", color: "red", height: "30px", textAlign: "center" }}>{errorMessage}</div>
						</div>
					</div>
				</ControlPannel>
				<ShowConditonally cond={!loggedIn}>
					<div className="hero" style={{}}>
						<img src={pcbanglogo} alt="" className="logo" />
						<div className="container headings">
							<h1 className="pcbang">PC&nbsp;BANG</h1>
							<h1 className="login">MAP</h1>
						</div>
					</div>
				</ShowConditonally>
				<div className={"parentcontainer w100 flex-jc-cr " + (loggedIn ? "" : "userview")}>
					<div className="bodycontainer w100 flex-jc-cr"
						style={{}}
					>
						<div className="body" style={{ boxSizing: "border-box", ...(!loggedIn && { marginTop: "-50px" }) }}
							onClick={(e) => {
								if (!e.target.classList.contains("device_tag")) {
									updateSelectedDeviceInLocalDevices(localDevices, setLocalDevices, selectedDevice);
									onDeselect();
								}
								setErrorMessage("")
							}}
						>
							<div className="image-container"

							>
								<div className="navpad h50 flex-ai-cr flex-jc-cr" style={{
									boxSizing: "border-box", border: "1px solid rgba(255,255,255,0.7)",
									opacity: loggedIn ? "1" : "0"
								}}>
									<div style={{ textAlign: "center", fontFamily: "Cera Round Pro", opacity: "0.7" }}>UNKNOWN POSITION</div>
								</div>
								<div className="navpad h20"></div>
								<img draggable="false" dragstart="false;" src={map} alt="" className="img" />

							</div>
							<GetDeviceDivs />
						</div>
					</div>
				</div>
			</Page>
		</localContext.Provider>
	);
}

export default Map;